import { NgModule, ModuleWithProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';

import {
  FEATURE_NAME,
  TOKEN_DATA_GETTER,
  API_LOGIN_ENDPOINT,
  API_LOGOUT_ENDPOINT,
  API_REFRESH_ENDPOINT,
  REFRESH_TOKEN_KEY,
  ROUTES_WITHOUT_TOKEN_CHECK
} from './auth.constant';
import { authReducer } from './auth.reducer';
import { AuthEffect } from './auth.effect';
import { AuthModuleConfig } from './auth.model';
import { authTokenInterceptorProvider } from './auth-token.interceptor';

@NgModule({
  imports: [
    // StoreModule.forFeature(FEATURE_NAME, authReducer),
    // EffectsModule.forFeature([ AuthEffect ])
  ]
})
export class ZefAuthRootModule {

}

export function defaultTokenGetter(response: any) {
  return response.auth;
}

@NgModule({})
export class ZefAuthModule {
  static forRoot(config?: AuthModuleConfig): ModuleWithProviders<ZefAuthRootModule> {
    return {
      ngModule: ZefAuthRootModule,
      providers: [
        provideState(FEATURE_NAME, authReducer),
        provideEffects(AuthEffect),
        {
          provide: TOKEN_DATA_GETTER,
          useValue: config && config.tokenDataGetter
            ? config.tokenDataGetter
            : defaultTokenGetter
        },
        {
          provide: API_LOGIN_ENDPOINT,
          useValue: config && config.loginEndpoint
            ? config.loginEndpoint
            : ''
        },
        {
          provide: API_LOGOUT_ENDPOINT,
          useValue: config && config.logoutEndpoint
            ? config.logoutEndpoint
            : ''
        },
        {
          provide: API_REFRESH_ENDPOINT,
          useValue: config && config.refreshEndpoint
            ? config.refreshEndpoint
            : ''
        },
        {
          provide: REFRESH_TOKEN_KEY,
          useValue: config && config.refreshTokenKey
            ? config.refreshTokenKey
            : 'refreshTokenId'
        },
        {
          provide: ROUTES_WITHOUT_TOKEN_CHECK,
          useValue: config?.routesWithoutTokenCheck ?? []
        },
        authTokenInterceptorProvider
      ]
    };
  }
}
